<template>
    <div>

            <div>

                <van-sticky><!-- 粘性布局，顶部的位置固定 -->
                    <div class="conopen" style="background-color: #f8f8f9">

                        <van-row type="flex" justify="space-between">
                            <van-col span="3">

                                <div style="padding: 17px">
                                    <van-icon name="arrow-left" size="15px" @click="onback"/><!-- icon图标，返回路劲 -->
                                </div>
                            </van-col>
                            <van-col span="18">
                                <!-- 搜索组件 -->
                                <form action="/">
                                    <van-search
                                            style="width: 100%;"
                                            v-model="keywordFilter"
                                            placeholder="SIM卡号"
                                            show-action
                                            @search="onFind"
                                    >
                                        <div slot="action" @click="onFind">搜索</div>
                                    </van-search>
                                </form>
                            </van-col>
                            <van-col span="3">
                                <div style="padding: 17px">
                                    <!-- icon图标，刷新页面 -->
                                    <van-icon name="replay" size="15px" @click="reststart"/>
                                </div>
                            </van-col>
                        </van-row>

                    </div>
                </van-sticky>
            </div>

<!--            <Cell title="SIM卡号" label="粤X99999（12345678901）" extra="梁朗朗"/>-->
        <Scroll :height="scrollHeight">
            <CheckboxGroup v-model="simInfoList">
            <div v-for="item in content">
            <Cell :label="item.positioningDeviceInfo==null?'无':item.positioningDeviceInfo.vehicleInfo==null?'无':'安装信息：'+item.positioningDeviceInfo.vehicleInfo.registrationNum+'('+item.positioningDeviceInfo.terminalNum+')'">
                <Checkbox :label="item.id">{{item.simNum}}</Checkbox>
                <Button size="small" type="info" @click="toShortMessages(item.simNum)" style="position: absolute;right: 5px;">发送短信</Button>
            </Cell>
            </div>
            </CheckboxGroup>
        </Scroll>
        <Row style="position: absolute;right:10px;bottom: 10px;">
        <Button v-if="simInfoList.length > 0" size="small" type="info" @click="tosimInfoChangeInstallerModal" style="position: relative;right: 80px;">分配SIM卡</Button>
        <Page :total="totalElements" :page-size="pageSize" :current="pageIndex" @on-change="setPage"
              @on-page-size-change="refreshPage" size="small" simple>
        </Page>
        </Row>
        <sim-info-change-installer-modal v-model="simInfoChangeInstallerModal" :initValue="simInfoChangeInstallerId" :listValue="simInfoList" @on-success="reststart"></sim-info-change-installer-modal>
    </div>
</template>

<script>
    import Vue from 'vue'
    import store from '@/store'
    import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'
    import SimInfoChangeInstallerModal from '@/views/im/components/sim-info-change-installer-modal'
    import {
        Cell,
        CellGroup,
        Field,
        Row,
        Col,
        Button,
        Dialog,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        Picker,
        Popup,
        Divider,
        Collapse,
        CollapseItem,
        DatetimePicker,
        Tag,
        DropdownMenu,
        DropdownItem,
        Sticky,
        Icon,
        Search,
        PullRefresh,
        List,
        Loading,
        Toast,
        NavBar,
    } from 'vant'

    Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu)
        .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem)
        .use(DatetimePicker).use(Icon).use(DropdownItem).use(Sticky).use(Search).use(PullRefresh).use(List).use(Loading).use(Toast)
        .use(NavBar);
    export default {
        name: "installersiminfos",
        components: {
            SimInfoChangeInstallerModal
        },
        data() {
            return {
                //SIM卡绑定安装维修员
                simInfoChangeInstallerModal: false,
                simInfoChangeInstallerId: null,
                simInfoList: [],

                scrollHeight:160,

                pageFilter: 30,
                pagesizeopts: [30, 50, 100, 200],
                keywordFilter: null,
                pageIndex: 1,
                sort: null,

                simInfoList: [],
                simInfoIds:[],
            }
        },
        methods:{
            // <!-- icon返回路劲 -->
            onback() {
                this.$router.push({
                    name: 'myMenu'
                })
            },
            //搜索
            onFind(){
                this.setPage(1)
            },
            // <!-- icon图标刷新方法 -->
            reststart() {
                this.setPage(this.pageIndex)
            },
            setPage (page) {
                console.log('setPage' + page)
                this.pageIndex = page

                let queryParams = []
                let sortParam = null

                if (this.sort) {
                    sortParam = genSortParam(this.sort.name, this.sort.asc)
                }

                if (this.operationFilter) {
                    queryParams.push(this.operationFilter)
                }
                if (this.stateFilter) {
                    queryParams.push(this.stateFilter)
                }

                store.dispatch('SimInfoServ_GetMyPage', {
                    params: null,
                    urlparams: {
                        q: queryParams,
                        ps: this.pageFilter,
                        p: page,
                        keyword: this.keywordFilter,
                        sort: sortParam
                    }
                }).then(() => {
                    this.listLoadding = false
                }).catch(err => {
                    this.listLoadding = false
                    this.$Message.error(err)
                })
            },
            // 刷新当前页
            refreshPage (value) {
                this.pageFilter = value
                this.setPage(this.pageIndex)
            },
            //分配SIM卡
            tosimInfoChangeInstallerModal(){
                console.log(this.simInfoList)
                this.simInfoChangeInstallerModal = true
            },
            toShortMessages(e){
                this.$router.push({
                    name: 'shortmessages',
                    params: {'simNum': e}
                })
            },
        },
        computed: {
            totalElements () {
                if (store.getters.get_SimInfo_GetMyPageResult) {
                    return store.getters.get_SimInfo_GetMyPageResult.totalElements
                } else {
                    return 0
                }
            },
            content () {
                if (store.getters.get_SimInfo_GetMyPageResult) {
                    return store.getters.get_SimInfo_GetMyPageResult.content
                } else {
                    return []
                }
            },
            pageSize () {
                if (store.getters.get_SimInfo_GetMyPageResult) {
                    return store.getters.get_SimInfo_GetMyPageResult.size
                } else {
                    return 0
                }
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.scrollHeight = window.innerHeight - 110
                window.onresize = () => {
                    this.scrollHeight = window.innerHeight - 110
                }
                this.setPage(1)
            })
        },
    }
</script>

<style scoped>
    .custom-title {
        margin-right: 4px;
        vertical-align: middle;
    }
</style>